// extracted by mini-css-extract-plugin
module.exports = {"backgroundOverlay":"ComUZ6Ci","backgroundOverlayOpen":"ewBXzz8a","container":"vt8nvvq5","containerOpen":"_ocwH7h7","header":"ADE86Mq3","body":"iJLemuZs","closeButton":"YHjEEsY1"};